import { render, staticRenderFns } from "./Content0.vue?vue&type=template&id=b510b9f6&scoped=true"
import script from "./Content0.vue?vue&type=script&lang=js"
export * from "./Content0.vue?vue&type=script&lang=js"
import style0 from "./Content0.vue?vue&type=style&index=0&id=b510b9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b510b9f6",
  null
  
)

export default component.exports